import React, { useId } from "react";

/* 라벨 옆 필수/선택 배지 — required={true} → 필수, required={false} → 선택, 미지정 → 없음 */
export function FieldBadge({ required }) {
  if (required === undefined || required === null) return null;
  const isReq = !!required;
  return (
    <span
      className="text-xs"
      style={{
        fontWeight: 800,
        padding: "2px 7px",
        borderRadius: 100,
        background: isReq ? "rgba(224,80,64,0.12)" : "rgba(74,154,90,0.12)",
        color: isReq ? "#E05040" : "#4a9a5a",
        border: `1px solid ${isReq ? "rgba(224,80,64,0.25)" : "rgba(74,154,90,0.3)"}`,
        letterSpacing: "0.05em",
        textTransform: "none",
        flexShrink: 0,
      }}
    >
      {isReq ? "필수" : "선택"}
    </span>
  );
}

export default function InputField({
  label,
  value,
  onChange, // onChange(value) — 값을 그대로 전달
  placeholder,
  type = "text",
  darkMode = false,
  icon,
  suffix,
  required,
  onFocus,
  onBlur,
  id,
  style = {},
  ...props
}) {
  const generatedId = useId();
  const inputId = id || `input-${generatedId.replace(/:/g, "")}`;
  const inputStyle = {
    width: "100%",
    padding: icon ? "15px 16px 15px 44px" : "15px 16px",
    background: darkMode ? "rgba(255,255,255,0.08)" : "rgba(255,255,255,0.95)",
    border: `1.5px solid ${darkMode ? "rgba(129,140,248,0.3)" : "rgba(99,102,241,0.25)"}`,
    borderRadius: 14,
    color: darkMode ? "#FFFFFF" : "#0F172A",
    fontWeight: 600,
    fontFamily: "inherit",
    outline: "none",
    boxSizing: "border-box",
    transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
    letterSpacing: "0.01em",
    minHeight: 50,
    ...style,
  };

  return (
    <div style={{ marginBottom: 18 }}>
      {label && (
        <label
          htmlFor={inputId}
          className="text-xs"
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            fontWeight: 700,
            letterSpacing: "0.08em",
            color: darkMode ? "rgba(165,180,252,0.9)" : "rgba(79,70,229,0.85)",
            marginBottom: 7,
            textTransform: "uppercase",
          }}
        >
          {label}
          <FieldBadge required={required} />
        </label>
      )}
      <div style={{ position: "relative" }}>
        {icon && (
          <span
            className="text-base"
            style={{
              position: "absolute",
              left: 14,
              top: "50%",
              transform: "translateY(-50%)",
              opacity: 0.6,
              pointerEvents: "none",
            }}
          >
            {icon}
          </span>
        )}
        <input
          id={inputId}
          type={type}
          value={value}
          onChange={(e) => onChange && onChange(e.target.value)}
          placeholder={placeholder}
          onFocus={(e) => {
            e.target.style.borderColor = darkMode ? "rgba(129,140,248,0.6)" : "rgba(99,102,241,0.5)";
            e.target.style.boxShadow = `0 0 0 3px ${darkMode ? "rgba(129,140,248,0.2)" : "rgba(99,102,241,0.15)"}`;
            e.target.style.background = darkMode ? "rgba(255,255,255,0.12)" : "#FFFFFF";
            onFocus && onFocus(e);
          }}
          onBlur={(e) => {
            e.target.style.borderColor = darkMode ? "rgba(129,140,248,0.3)" : "rgba(99,102,241,0.25)";
            e.target.style.boxShadow = "none";
            e.target.style.background = darkMode ? "rgba(255,255,255,0.08)" : "rgba(255,255,255,0.95)";
            onBlur && onBlur(e);
          }}
          className="text-base"
          style={inputStyle}
          {...props}
        />
        {suffix && (
          <span
            className="text-base"
            style={{
              position: "absolute",
              right: 14,
              top: "50%",
              transform: "translateY(-50%)",
              opacity: 0.5,
            }}
          >
            {suffix}
          </span>
        )}
      </div>
    </div>
  );
}
